import { lazy } from 'react';

import { BASE_PROJECT_PATH } from '@/routes';

// const BASE_PROJECT_PATH = `/projects/:projectId`;
const EmailEntryPrintPage = lazy(
  () =>
    import(
      '@/components/project/Inbox2/pages/EmailEntryPrintPage/EmailEntryPrintPage'
    )
);
const InboxEntryViewerPage = lazy(
  () =>
    import(
      '@/components/project/Inbox2/pages/InboxEntryViewerPage/InboxEntryViewerPage'
    )
);

export const INBOX_PATH = `${BASE_PROJECT_PATH}/inbox`;
export const INBOX_ENTRY_VIEWER_PAGES_PATH = `${INBOX_PATH}/:inboxEntryId`;

export const INBOX_PATHS = {
  INBOX_PATH,
  INBOX_ENTRY_VIEWER_PAGES_PATH,
};

export const INBOX_PAGE_ROUTES = {
  email_enttry_print_preview: {
    path: `${BASE_PROJECT_PATH}/inbox/:inboxEntryId/emails/:emailId`,
    exact: true,
    component: EmailEntryPrintPage,
  },
  inbox_file_entry: {
    path: INBOX_ENTRY_VIEWER_PAGES_PATH,
    exact: true,
    component: InboxEntryViewerPage,
  },
};
